import { useTranslation } from "react-i18next";
import { PRIORITY_META, PRIORITY_ORDER } from "./playbookUtils";

export const PriorityMenu = ({ current, onChoose, onClose }) => {
  const { t } = useTranslation();

  return (
    <div
      role="menu"
      aria-label={t("pages.settings.signalsPlaybooks.editor.priorityMenuLabel")}
      className="absolute left-0 top-[34px] z-30 w-[140px] rounded-lg border border-gray-200 bg-white p-1 shadow-lg"
    >
      {PRIORITY_ORDER.map((value) => {
        const meta = PRIORITY_META[value];
        const isCurrent = value === current;
        return (
          <button
            key={value}
            type="button"
            role="menuitemradio"
            aria-checked={isCurrent}
            onClick={() => {
              onChoose(value);
              onClose();
            }}
            className={`flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-xs text-gray-700 hover:bg-gray-100 ${
              isCurrent ? "bg-gray-50" : ""
            }`}
          >
            <span
              className={`h-2 w-2 flex-none rounded-full ${meta.dotClass}`}
            />
            <span className="flex-1">
              {t(`pages.settings.signalsPlaybooks.priority.${value}`)}
            </span>
            {isCurrent && <span className="text-blue-600">{"✓"}</span>}
          </button>
        );
      })}
    </div>
  );
};
